
Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};

Greenmile.Checks.EventCheck.LunchAlert = {

	template: () => ({
			tag: 'div',
			items: [
				{
					items: [
						{
							tag: 'label',
							html: `${Monet.I18n.getResourcesByKey('event.check.lunchAlert.type')}:`,
							attributes: {
								class: 'control-label',
								for: 'lunch_alert_combo',
							},
						},
						{
							tag: 'select',
							items: [
								{
									tag: 'option',
									html: Monet.I18n.getResourcesByKey('event.lunchAlert.rule.onDuty'),
									attributes: {
										value: 'ON_DUTY',
									},
								},
								{
									tag: 'option',
									html: Monet.I18n.getResourcesByKey('event.lunchAlert.rule.offDuty'),
									attributes: {
										value: 'OFF_DUTY',
									},
								},
							],
							attributes: {
								id: 'lunch_alert_combo',
							},
						},
						{
							tag: 'label',
							html: `${Monet.I18n.getResourcesByKey('event.check.lunchAlert.minutes')}:`,
							attributes: {
								id: 'lunch_alert_param_label',
								class: 'control-label',
								for: 'lunch_alert_param',
							},
						},
						{
							items: [
								{
									tag: 'input',
									attributes: {
										type: 'number',
										name: 'lunch_alert_param',
										maxlength: '10',
										min: '0',
										alt: '',
										value: '',
										size: '11',
										id: 'lunch_alert_param',
										class: 'modelAttribute textField numberPicker mandatory',
										autocomplete: 'off',
									},
								},
							],
							attributes: {
								class: 'controls',
							},
						},
					],
					attributes: {
						class: 'control-group',
					},
				},
			],
		}),

	assignParameter: (jsonParam) => {
		const combo = $('#lunch_alert_combo');
		const field = $('#lunch_alert_param');
		if (jsonParam) {
      jsonParam = JSON.parse(jsonParam);
      if (jsonParam.eventType) {
        combo.val(jsonParam.eventType);
      }
      if (jsonParam.timeLimit) {
        field.val(jsonParam.timeLimit);
			}
    }
	},

	retrieveParameter: () => {
    const value = parseInt($('#lunch_alert_param').val(), 10);
    const combo = $('#lunch_alert_combo').val();

    if(combo) {
    	return JSON.stringify({timeLimit: value, eventType: combo });
		} else {
      console.log("Greenmile.Event.EventCheck in retrieveParameter don't have a default parameter");
		}
	}

};
